import Usuario from './Usuario'
import AutoInfracaoTransito from "./AutoInfracaoTransito";
import TipoVeiculo from "./TipoVeiculo";
import GrupoMarcaModelo from "./GrupoMarcaModelo";
import StatusAutoInfracaoTransito from "./StatusAutoInfracaoTransito";
import LoteAitAplicativo from "./LoteAitAplicativo";


class AitAplicativo {
    constructor(
        {
            id = null,
            hash = null,
            auto_infracao_transito_id = null,
            reserva_faixa_ait_id = null,
            status_auto_infracao_transito = {},
            status_auto_infracao_transito_id = null,
            placa_veiculo = null,
            tipo_veiculo_id = null,
            lote_ait_aplicativo_id = null,
            codigo_equipamento = null,
            tipo_veiculo = {},
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            usuario = {},
            auto_infracao_transito = {},
            grupo_marca_modelo = {},
            lote_ait_aplicativo = {},
            grupo_marca_modelo_id = null,
            cancelar = null,
            observacao = null,
            endereco = {}
            


        } = {}
    ) {

        this.id = id;
        this.hash = hash;
        this.auto_infracao_transito_id = auto_infracao_transito_id;
        this.reserva_faixa_ait_id = reserva_faixa_ait_id;
        this.status_auto_infracao_transito_id = status_auto_infracao_transito_id;
        this.tipo_veiculo_id = tipo_veiculo_id;
        this.placa_veiculo = placa_veiculo;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.codigo_equipamento = codigo_equipamento;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.grupo_marca_modelo_id = grupo_marca_modelo_id;
        this.observacao = observacao;
        this.lote_ait_aplicativo_id = lote_ait_aplicativo_id;
        this.cancelar = cancelar ? true : false;
        this.endereco = endereco;
        
        this.auto_infracao_transito = auto_infracao_transito ? new AutoInfracaoTransito(auto_infracao_transito) : new AutoInfracaoTransito();
        this.status_auto_infracao_transito = status_auto_infracao_transito ? new StatusAutoInfracaoTransito(status_auto_infracao_transito) : new StatusAutoInfracaoTransito();
        this.tipo_veiculo = tipo_veiculo ? new TipoVeiculo(tipo_veiculo) : new TipoVeiculo();
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.grupo_marca_modelo = grupo_marca_modelo ? new GrupoMarcaModelo(grupo_marca_modelo) : new GrupoMarcaModelo();
        this.lote_ait_aplicativo = lote_ait_aplicativo ? new LoteAitAplicativo(lote_ait_aplicativo) : new LoteAitAplicativo();

        
    }
}

export default AitAplicativo;